import './Loader.css'

function Loader({ fullScreen = false, size = 'md', text = '' }) {
  const loader = (
    <div className={`loader-container ${fullScreen ? 'fullscreen' : ''}`}>
      <div className={`loader loader-${size}`}>
        <div className="loader-ring"></div>
        <div className="loader-ring"></div>
        <div className="loader-ring"></div>
      </div>
      {text && <p className="loader-text">{text}</p>}
    </div>
  )

  return loader
}

export default Loader
